import { render, staticRenderFns } from "./StudipFileSize.vue?vue&type=template&id=bf3a4ca2&"
import script from "./StudipFileSize.vue?vue&type=script&lang=js&"
export * from "./StudipFileSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports